import Vue from 'vue'
import Router from 'vue-router'
import Home from './views/Home.vue'
import Login from './views/Login.vue'
import Register from './views/Register'
import TermsAndCondition from './views/TermsAndCondition'
import PrivacyPolicy from './views/PrivacyPolicy'
import Reset from './views/Reset'
import ResetPassword from './views/ResetPassword'
import UnSubscribe from './views/UnSubscribe'
import NF from './views/NotFound'
import Statistics from './views/Statistics'
import store from './store/store'
// import JobAds from './views/JobAds'
import bulletinBoard from './views/BulletinBoard'
import videoPage from './views/VideoPage'
import Confirm from "./views/Confirm";
import Profile from "./views/Profile.vue"
import Rating from "./views/Rating.vue"
import Posts from "./views/Posts";
import SocialLogin from "./views/SocialLogin";
import Search from "./views/Search";
import Messages from "./views/Messages";
import Password from "./views/Password.vue";

Vue.use(Router);

const ifNotAuthenticated = (to, from, next) => {
  if (!store.getters.isLogin) {
    next();
    return;
  }
  next({name: 'search'});
};

const ifAuthenticated = (to, from, next) => {
  if (store.getters.isLogin) {
    next();
    return;
  }
  next({name: 'login'});
};

const scrollTop = {};

const router = new Router({
  mode: 'history',
  base: process.env.BASE_URL || '/',
  routes: [
    {
      path: '/',
      name: 'home',
      component: Home,
      children: [
        {
          path: 'login',
          name: 'login',
          component: Login,
          beforeEnter: ifNotAuthenticated
        },
        {
          path: 'register',
          name: 'register',
          component: Register
        },
        {
          path: 'reset',
          name: 'reset',
          component: Reset
        },
        {
          path: 'unsubscribe',
          name: 'unSubscribe',
          component: UnSubscribe,
          props: (route) => ({uid: route.query.uid})
        },
        {
          path: 'reset-password',
          name: 'resetPassword',
          component: ResetPassword,
          props: (route) => ({access_token: route.query.access_token})
        },
        {
          path: 'confirm',
          name: 'confirm',
          component: Confirm,
          props: (route) => ({token: route.query.token, uid: route.query.uid})
        },
        {
          path: 'social-login',
          name: 'socialLogin',
          component: SocialLogin,
          beforeEnter: ifNotAuthenticated,
          props: (route) => ({access_token: route.query['access-token']})
        },
        {
          path: '/terms-and-condition',
          name: 'termsAndCondition',
          component: TermsAndCondition
        },
        {
          path: '/privacy-policy',
          name: 'privacyPolicy',
          component: PrivacyPolicy
        },
      ]
    },
    {
      path: '/posts/:page',
      name: 'posts',
      component: Posts,
      beforeEnter: ifAuthenticated,
    },
    {
      path: '/search',
      name: 'search',
      component: Search,
    },
    {
      path: '/messages',
      name: 'messages',
      component: Messages,
      beforeEnter: ifAuthenticated,
    },
    {
      path: '/statistics/:type?',
      name: 'statistics',
      component: Statistics
    },
    // {
    //   path: '/jobAds',
    //   name: 'jobAds',
    //   component: JobAds,
    //   beforeEnter: ifAuthenticated
    // },
    {
      path: '/bulletinBoard',
      name: 'bulletinBoard',
      component: bulletinBoard,
      beforeEnter: ifAuthenticated
    },
    {
      path: '/videoPage/:hashTag?',
      name: 'videoPage',
      component: videoPage
    },
    {
      path: '/profile/:id?',
      name: 'profile',
      component: Profile
    },
    {
      path: '/rating',
      name: 'rating',
      component: Rating,
      beforeEnter: ifAuthenticated,
    },
    {
      path: '/about',
      name: 'about',
      // route level code-splitting
      // this generates a separate chunk (about.[hash].js) for this route
      // which is lazy-loaded when the route is visited.
      component: () => import(/* webpackChunkName: "about" */ './views/About.vue')
    },
    {
      path: '/password',
      name: 'password',
      component: Password,
      beforeEnter: ifAuthenticated
    },
    { path: '*', component: NF },
    // { path: '/', redirect: to =>{
    //   return { name: 'home' }}
    // },
  ],
  scrollBehavior (to /*, from, savedPosition */) {
    if(scrollTop[to.name]) {
      let el = document.getElementById('scroll');
      if(el) {
        el.scrollTop = scrollTop[to.name];
        delete scrollTop[to.name];
      }
    }
  }
});

router.beforeEach((to, from, next) => {
  let el = document.getElementById('scroll');
  if(el && (from.name==='posts')) {
    scrollTop[from.name] = el.scrollTop;
  }
  next();
});

export default router;
